const jaCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "ファイル名を入力...",
    description: "Placeholder for file name input",
  },
};

export default jaCreateFile;
